/**
 * Einstellungs-Registry (Paket 6).
 */
import { ZEITSTRAHL_ZEITRAEUME, ZEITSTRAHL_ZEITRAUM_SCHLUESSEL, } from "./zeitstrahl.js";
export const KI_ARBEITSLAUF_VERWENDUNGEN = [
    "metarr_anliegen",
    "akzeptanzkriterien",
    "review",
    "hausmeister",
];
export const KI_ARBEITSLAUF_EINSTELLUNGEN = {
    metarr_anliegen: "ki_arbeitslauf_metarr_anliegen",
    akzeptanzkriterien: "ki_arbeitslauf_akzeptanzkriterien",
    review: "ki_arbeitslauf_review",
    hausmeister: "ki_arbeitslauf_hausmeister",
};
export const KI_ANBIETER_ARTEN = [
    "deepseek_api",
    "openai_api",
    "openai_subscription",
    "xai_api",
    "xai_subscription",
    "anthropic_subscription",
];
/**
 * Der Katalog ist bewusst datengetrieben. Ein weiterer Anbieter braucht damit
 * keinen neuen Oberflächen-Ablauf, sondern nur Adapter und Katalogeintrag.
 */
export const KI_ANBIETER_KATALOG = [
    {
        art: "deepseek_api",
        anbieter: "deepseek",
        name: "DeepSeek",
        zugangsart: "api_schluessel",
        basisUrl: "https://api.deepseek.com",
        schluesselUrl: "https://platform.deepseek.com/api_keys",
        verfuegbar: true,
        hinweis: "Direkter Zugang über einen DeepSeek API-Schlüssel.",
    },
    {
        art: "openai_api",
        anbieter: "openai",
        name: "OpenAI API",
        zugangsart: "api_schluessel",
        basisUrl: "https://api.openai.com/v1",
        schluesselUrl: "https://platform.openai.com/api-keys",
        verfuegbar: true,
        hinweis: "Direkter Zugang über einen OpenAI Projekt-API-Schlüssel.",
    },
    {
        art: "openai_subscription",
        anbieter: "openai",
        name: "OpenAI über Codex CLI",
        zugangsart: "subscription",
        basisUrl: null,
        schluesselUrl: null,
        verfuegbar: true,
        hinweis: "Läuft über die auf dem Server angemeldete Codex CLI statt über einen " +
            "API-Schlüssel. Die Anmeldung liegt in CODEX_HOME; Läufe zählen gegen " +
            "das Kontingent des Abonnements.",
    },
    {
        art: "xai_api",
        anbieter: "xai",
        name: "Grok",
        zugangsart: "api_schluessel",
        basisUrl: "https://api.x.ai/v1",
        schluesselUrl: "https://console.x.ai/team/default/api-keys",
        verfuegbar: true,
        hinweis: "Direkter Zugang zu Grok über einen xAI API-Schlüssel.",
    },
    {
        art: "xai_subscription",
        anbieter: "xai",
        name: "Grok über die Grok CLI",
        zugangsart: "subscription",
        basisUrl: null,
        schluesselUrl: null,
        verfuegbar: true,
        hinweis: "Läuft über die auf dem Server angemeldete Grok CLI statt über einen " +
            "API-Schlüssel. Die Anmeldung liegt in GROK_HOME; Läufe zählen gegen " +
            "das Kontingent des Abonnements.",
    },
    {
        art: "anthropic_subscription",
        anbieter: "anthropic",
        name: "Claude über die Claude CLI",
        zugangsart: "subscription",
        basisUrl: null,
        schluesselUrl: null,
        verfuegbar: true,
        hinweis: "Läuft über die auf dem Server angemeldete Claude-Code-CLI statt über " +
            "einen API-Schlüssel. Die Anmeldung liegt in CLAUDE_HOME; Läufe zählen " +
            "gegen das Kontingent des Abonnements.",
    },
];
/**
 * Welche Regler ein Zugang aus der Serverkonfiguration überhaupt anbietet.
 *
 * Nicht jeder Regler wirkt bei jedem Weg. Ein Schlüsselzugang spricht über
 * HTTP; dort tragen `denken` und die Antwortlänge eigene Felder im
 * Anfragekörper. Der Abo-Zugang geht durch `codex exec`, und die CLI nimmt
 * davon nichts entgegen — sie kennt Modell und Denkstufe, mehr nicht.
 *
 * Ein Regler ohne Wirkung ist schlimmer als kein Regler: Er behauptet eine
 * Einstellung, die nirgends ankommt. Genau das war am 23.08.2026 der Fall, als
 * eine gewählte Denkstufe still verfiel, weil der Adapter sie nicht las.
 *
 * Steht hier und nicht im Dienst, weil Oberfläche und Server dieselbe Antwort
 * brauchen: Die eine blendet aus, der andere weist ab.
 */
export function einstellbareFelderFuerUmgebung(zugangsart) {
    return zugangsart === "subscription"
        ? { denken: false, denkstufe: true, maxTokens: false }
        : { denken: true, denkstufe: true, maxTokens: true };
}
export const EINSTELLUNGEN_REGISTRY = [
    {
        schluessel: "max_titel_laenge",
        label: "Maximale Titellänge",
        beschreibung: "Begrenzt die Länge von Aufgabentiteln. Längere Eingaben werden abgewiesen.",
        standard: "500",
        bereich: "instanz",
        typ: "ganze_zahl",
        minimum: 1,
        maximum: 5000,
    },
    {
        schluessel: "standard_workflow_strikt",
        label: "Strikter Workflow",
        beschreibung: "Wenn aktiv, sind nur definierte Statusübergänge erlaubt; sonst jeder Wechsel.",
        standard: "false",
        bereich: "projekt",
        typ: "boolesch",
    },
    {
        schluessel: "digest_opt_in",
        label: "Tageszusammenfassung",
        beschreibung: "Steuert, ob die Person eine tägliche E-Mail-Zusammenfassung wünscht.",
        standard: "false",
        bereich: "person",
        typ: "boolesch",
    },
    {
        schluessel: "review_app_muster",
        label: "Review-App-Adresse",
        beschreibung: "Adressmuster der Review-Umgebung eines offenen Merge Requests; {iid} wird durch die MR-Nummer ersetzt. Leer bedeutet: keine Review-Apps.",
        standard: "",
        bereich: "projekt",
        typ: "text",
        maxLaenge: 500,
        // Leer oder eine https-Adresse, die den Platzhalter trägt — ohne ihn
        // zeigten alle Merge Requests auf dieselbe Umgebung.
        muster: "^$|^https://\\S*\\{iid\\}\\S*$",
    },
    {
        schluessel: ZEITSTRAHL_ZEITRAUM_SCHLUESSEL,
        label: "Zeitraum des Meilensteinbands",
        beschreibung: "Welchen Ausschnitt das Zeitband im Reiter Meilensteine zeigt. Automatisch folgt es den Fristen der aufgeplanten Aufgaben; eine feste Spanne zeigt ab dem laufenden Monat immer gleich viele Monate.",
        standard: "automatisch",
        bereich: "projekt",
        typ: "auswahl",
        werte: ZEITSTRAHL_ZEITRAEUME,
    },
];
export function findeEinstellung(schluessel) {
    return EINSTELLUNGEN_REGISTRY.find((e) => e.schluessel === schluessel);
}
/**
 * Prüft und kanonisiert einen Wert anhand der Registry.
 * `null` bedeutet ungültig.
 */
export function normalisiereEinstellungswert(eintrag, roh) {
    const wert = roh.trim();
    if (eintrag.typ === "boolesch") {
        return wert === "true" || wert === "false" ? wert : null;
    }
    if (eintrag.typ === "text") {
        if (eintrag.minLaenge !== undefined && wert.length < eintrag.minLaenge) {
            return null;
        }
        if (eintrag.maxLaenge !== undefined && wert.length > eintrag.maxLaenge) {
            return null;
        }
        if (eintrag.muster !== undefined && !new RegExp(eintrag.muster).test(wert)) {
            return null;
        }
        return wert;
    }
    if (eintrag.typ === "auswahl") {
        return eintrag.werte.includes(wert) ? wert : null;
    }
    if (!/^-?\d+$/.test(wert))
        return null;
    const zahl = Number(wert);
    if (!Number.isSafeInteger(zahl))
        return null;
    if (eintrag.minimum !== undefined && zahl < eintrag.minimum)
        return null;
    if (eintrag.maximum !== undefined && zahl > eintrag.maximum)
        return null;
    return String(zahl);
}
//# sourceMappingURL=einstellungen.js.map